import { getFullLanguageFromDefaultMapping } from 'event-widgets/utils/getMatchingLocale';

/**
 * Function to retrieve datatag resolutions from a service or anywhere else.
 * @param {*} dispatch - the store dispatch function.
 * @param {*} getState - the store getState function.
 * @param {*} datatags - the list of datatgs to get resolutions for
 * @param {*} options - additional options:
 *      successCallback - callback to fire on successful load of data tags. Takes a single parameter
 *          containing an array of the resolved text (in the same order as the passed in dataTags parameter).
 *      failureCallback - callback to fire on failed load of data tags. Takes a single error parameter.
 *      context - generally to be used to identify the entity you are resolving tags against in your service.
 *      locale - generally to be used to identify what language you are resolving tags against in your service.
 *      dataTagFormatRegExp - use if your service supports configuring this.
 *      translate - Text translation function. Generally used inside of the dataTagMakeServiceCall function if its
 *          implemented to return example resolutions. When calling an actual datatag service to get real resolutions,
 *          we would generally expect the service to use the locale property to return the correct text instead.
 */
export default async function fetchTextResolverDatatags(dispatch, getState, datatags, options) {
  const { clients: { DataTagsResolutionClient }, accessToken,
    event: { cultureCode } } = getState();
  const languageCode = getFullLanguageFromDefaultMapping(cultureCode);
  const resolvedText = await DataTagsResolutionClient.resolve(accessToken, datatags, languageCode);
  options.successCallback(resolvedText);
}
